/* Alessia Rose · mejoras del carrito lateral
   - Contador de artículos en la cabecera del panel
   - Barra de envío gratis (solo si se configura un umbral > 0)
   - "Seguir comprando" y "Vaciar carrito" bajo los iconos de pago
   - En /cart: si el panel funciona, se abre el panel y se oculta el carrito de respaldo.
     Si el JavaScript falla, el carrito de respaldo (sin JS) sigue visible. */
(function () {
  var cfg = window.AlessiaCart || {};
  var cart = null;
  var timer = null;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    try {
      return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: cfg.currency || 'EUR' });
    } catch (e) {
      return (cents / 100).toFixed(2) + ' €';
    }
  }

  function refresh() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { cart = data; enhance(); })
      .catch(function () { enhance(); });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 60);
  }

  function clearCart(drawer, btn) {
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    fetch(root + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function () {
        // Sin cabecera Accept: en /products/* devolvería el JSON del producto en vez de las secciones
        return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble');
      })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parser = new DOMParser();
        var fresh = sections && sections['cart-drawer']
          ? parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('.drawer__inner')
          : null;
        var inner = drawer.querySelector('.drawer__inner');
        if (!fresh || !inner) throw new Error('cart-drawer section not rendered');
        drawer.classList.add('is-empty');
        inner.innerHTML = fresh.innerHTML;
        if (sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          var freshBubble = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'alessia-clear', cartData: { item_count: 0, items: [] } });
        }
        var focusTarget = drawer.querySelector('.drawer__inner-empty .button, .drawer__close');
        if (focusTarget) focusTarget.focus();
        refresh();
      })
      .catch(function () {
        // Si algo falla, recargamos para mostrar el estado real del carrito
        window.location.reload();
      });
  }

  function enhance() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var inner = drawer.querySelector('.drawer__inner');
    if (!inner) return;
    var header = inner.querySelector('.drawer__header');
    var heading = header && header.querySelector('.drawer__heading');

    if (heading && cart) {
      var count = heading.querySelector('.ar-count');
      if (!count) {
        count = document.createElement('span');
        count.className = 'ar-count';
        heading.appendChild(count);
      }
      count.textContent = '(' + cart.item_count + ')';
    }

    var threshold = Number(cfg.freeShippingThreshold) || 0;
    if (threshold > 0 && header && cart && cart.item_count > 0) {
      var bar = inner.querySelector('.ar-ship');
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'ar-ship';
        bar.innerHTML = '<p class="ar-ship__text" role="status"></p><div class="ar-ship__track"><span class="ar-ship__fill"></span></div>';
        header.insertAdjacentElement('afterend', bar);
      }
      var remaining = threshold - cart.total_price;
      bar.querySelector('.ar-ship__text').innerHTML = remaining > 0
        ? 'Te faltan <strong>' + money(remaining) + '</strong> para disfrutar del envío gratis'
        : 'Tu pedido tiene <strong>envío gratis</strong>';
      var pct = Math.min(100, (cart.total_price / threshold) * 100);
      requestAnimationFrame(function () { bar.querySelector('.ar-ship__fill').style.width = pct + '%'; });
    }

    var ctas = inner.querySelector('.cart__ctas');
    if (ctas && !inner.querySelector('.ar-actions')) {
      var actions = document.createElement('div');
      actions.className = 'ar-actions';

      var cont = document.createElement('button');
      cont.type = 'button';
      cont.className = 'ar-continue';
      cont.textContent = 'Seguir comprando';
      cont.addEventListener('click', function () { drawer.close && drawer.close(); });

      var clear = document.createElement('button');
      clear.type = 'button';
      clear.className = 'ar-continue ar-clear';
      clear.textContent = 'Vaciar carrito';
      clear.addEventListener('click', function () { clearCart(drawer, clear); });

      actions.appendChild(cont);
      actions.appendChild(clear);
      ctas.insertAdjacentElement('afterend', actions);
    }
  }

  function cartPage() {
    var page = document.querySelector('[data-ar-cart-page]');
    var drawer = document.querySelector('cart-drawer');
    if (!page || !drawer || !customElements.get('cart-drawer') || typeof drawer.open !== 'function') return;
    page.classList.add('ar-cart-page--drawer');
    var reopen = page.querySelector('[data-ar-open-drawer]');
    if (reopen) reopen.addEventListener('click', function () { drawer.open(reopen); });
    drawer.open();
  }

  function init() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    refresh();
    new MutationObserver(function () {
      var inner = drawer.querySelector('.drawer__inner');
      if (!inner) return;
      var heading = inner.querySelector('.drawer__heading');
      var missing = (heading && !heading.querySelector('.ar-count')) ||
        (inner.querySelector('.cart__ctas') && !inner.querySelector('.ar-actions'));
      if (missing) schedule();
    }).observe(drawer, { childList: true, subtree: true });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    }

    if (customElements.get('cart-drawer')) {
      cartPage();
    } else if (customElements.whenDefined) {
      customElements.whenDefined('cart-drawer').then(cartPage);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
